<template>
  <main class="page-accounts page-main__wrapper layout">
    <!-- 条件查询部分 -->
    <section class="filter-box">
      <div class="top-btns">
        <!-- S 批量管理组件 -->
        <batch-handle-drop :disabled="!hasRecord" @action="$_batching" class="handle-drop"></batch-handle-drop>
        <!-- E 批量管理组件 -->
        <el-button @click="$_modify(-1)" class="btn__add">新增账号</el-button>
        <!-- 批量新增账号 -->
        <el-button @click="$_batchAccount" class="btn__add">批量新增账号</el-button>
        <el-button @click="$_batchAuth" class="btn__add">批量配置权限</el-button>
      </div>
      <el-form :inline="true" class="filter-form">
        <el-form-item label="登录账号:">
          <el-input v-model="filter.accountName" style="width: 110px;"></el-input>
        </el-form-item>
        <el-form-item label="登录手机:">
          <el-input v-model="filter.phone" style="width: 110px;"></el-input>
        </el-form-item>
        <el-form-item label="用户名称:">
          <el-input v-model="filter.userName" style="width: 110px;"></el-input>
        </el-form-item>
        <el-form-item label="登录邮箱:">
          <el-input v-model="filter.email" style="width: 110px;"></el-input>
        </el-form-item>
        <el-form-item label="账号ID:">
          <el-input v-model.trim="filter.uid" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="状态:">
          <el-select v-model="filter.status" style="width: 110px;" placeholder="请选择状态">
            <el-option
              v-for="item in filter.statuses"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$_reset" class="reset__btn">重置</el-button>
        </el-form-item>
      </el-form>
    </section>

    <main class="table-box">
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        :height="tableHeight"
        :rowClassName="$_getRowClass"
        v-loading="isLoading"
        border
        stripe
        tooltip-effect="dark"
        @selection-change="selectList = $event"
      >
        <el-table-column type="selection" align="center" width="50"></el-table-column>
        <el-table-column label="操作" width="300" :resizable="false">
          <template slot-scope="scope">
            <el-button class="edit__btn" @click="$_modify(scope.$index, scope.row)">编辑</el-button>
            <cd-switch
              v-model="scope.row.status"
              @input="$_switch(scope.$index, scope.row)"
              :true-value="1"
              :false-value="2"
            >
              <span slot="open">启用</span>
              <span slot="close">停用</span>
            </cd-switch>

            <el-button class="delete__btn" @click="$_changeStatus(scope.row)">删除</el-button>
          </template>
        </el-table-column>

        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
          v-if="!column.component"
        ></el-table-column>
        <el-table-column :prop="column.key" :label="column.label" :width="column.width" v-else>
          <template slot-scope="scope">
            <component :is="column.component" :row="scope.row"></component>
          </template>
        </el-table-column>

        <div v-show="!isLoading" class="table-list__empty" slot="empty">列表暂无数据</div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getAccounts"
      ></cd-pagination>
    </div>

    <modal-modify
      v-if="modal.show && modal.template === 'modify'"
      :title="modal.title"
      :formType="modal.type"
      :userData="modal.data"
      @callback="$_callback"
      @close="$_close"
    ></modal-modify>

    <batch-account
      v-if="modal.show && modal.template === 'batch'"
      :title="modal.title"
      @callback="$_callback"
      @close="$_close"
    ></batch-account>

    <batch-auth
      v-if="modal.show && modal.template === 'batch-auth'"
      :title="modal.title"
      @callback="$_callback"
      @close="$_close"
    ></batch-auth>
  </main>
</template>

<script>
import * as Utils from "@/plugins/utils";
import resize from "@/mixins/resize";
import modalModify from "./modal-modify";
import BatchAccount from "./modal-batch-account";
import BatchAuth from "./modal-batch-auth";

const columns = [
  { key: "uid", label: "账号ID", width: 120 },
  { key: "accountName", label: "登录账号", width: 120 },
  { key: "phoneTxt", label: "登录手机", width: 120 },
  { key: "userName", label: "用户名称", width: 120 },
  { key: "email", label: "登录邮箱", width: 210 },
  { key: "memo", label: "备注", width: 280 },
  { key: "creater", label: "创建人", width: 120 },
  { key: "createTime", label: "创建时间", width: 160 },
  { key: "operator", label: "最后编辑人", width: 120 },
  { key: "updateTime", label: "最后编辑时间", width: 160 },
];
export default {
  name: "account-users",
  mixins: [resize],
  data() {
    return {
      isLoading: true,
      filter: {
        uid: "",
        accountName: "",
        userName: "",
        phone: "",
        email: "",
        statuses: [
          { value: 0, label: "全部" },
          { value: 1, label: "启用" },
          { value: 2, label: "停用" },
        ],
        status: 0, // 0: 全部, 1: 启用, 2: 停用
      },
      tableHeight: null,
      dataList: [],
      selectList: [],
      columns,
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0,
      },
      modal: {
        show: false,
        type: "add",
        template: "",
        data: {},
      },
    };
  },
  computed: {
    hasRecord() {
      return this.selectList.length > 0;
    },
  },
  methods: {
    // 批量导入账号
    $_batchAccount() {
      this.modal.title = "批量新增账号";
      this.modal.template = "batch";
      this.modal.show = true;
    },
    // 批量配置权限
    $_batchAuth() {
      this.modal.title = "批量配置系统权限";
      this.modal.template = "batch-auth";
      this.modal.show = true;
    },
    // 搜索
    $_search() {
      let { uid, phone } = this.filter;
      if (uid !== "" && uid.match(/^\d+$/) === null) {
        $MessageBox.alert({ content: "账号ID为整数类型" });
        return false;
      }
      if (phone !== "" && !Utils.isPhone(phone)) {
        $MessageBox.alert({ content: "请输入正确的手机号格式" });
        return false;
      }
      this.pagination.pageNow = 1;
      this.$_getAccounts();
    },
    // 重置
    $_reset() {
      this.filter.accountName = "";
      this.filter.phone = "";
      this.filter.userName = "";
      this.filter.email = "";
      this.filter.status = 0;
      this.filter.uid = "";
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getAccounts();
    },
    // 查询接口列表
    $_getAccounts() {
      // this.dataList.splice(0);
      this.isLoading = true;
      this.$refs.tableList.clearSort();
      let { uid, accountName, phone, userName, email, status } = this.filter;
      let { pageNow, pageSize } = this.pagination;
      const postData = {
        uid: parseInt(uid),
        accountName,
        phone,
        userName,
        email,
        status,
        pageNow,
        pageSize,
      };
      this.$service.post("getUsers", postData).then((result) => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.map((item) => {
            let phoneTxt = "";
            typeof item.phone !== "undefined" && item.phone !== ""
              ? (phoneTxt = item.phone)
              : (phoneTxt = " - ");
            return {
              phoneTxt,
              ...item,
            };
          });
        }
        this.isLoading = false;
      });
    },
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 新增/编辑账号成功回调
    $_callback() {
      this.$_close();
      this.$_getAccounts();
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "";
    },
    // 新增/编辑
    async $_modify($index, row) {
      this.modal.type = "add";
      this.modal.data = { uid: 0 };
      this.modal.title = "新增账号";
      if ($index !== -1) {
        this.isLoading = true;
        this.modal.type = "edit";
        this.modal.title = "编辑账号";
        let result = await this.$service.post("getUser", { uid: row.uid });
        this.modal.data = JSON.parse(JSON.stringify(result.data));
        this.isLoading = false;
      }
      this.modal.template = "modify";
      this.modal.show = true;
    },
    // 更新品牌状态 3-删除
    $_changeStatus(row) {
      status = status || row.status;
      const self = this;
      let content = `
				<div>您的账户已开通其他三方系统（如OAC系统），若删除后将无法使用，是否删除?</div>
			`;
      let uidList = [row.uid];
      $MessageBox.confirm({
        content,
        onOk() {
          self.$service
            .post("updateUserStatus", {
              uidList,
              status: 3,
            })
            .then((result) => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self.$_getAccounts();
                  },
                });
              }
            });
        },
      });
    },
    // 启用/停用
    $_switch($index, row, status) {
      status = status || row.status;
      const self = this;
      let uidList = [row.uid];
      const callback = (content) => {
        $MessageBox.alert({
          content,
          onOk() {
            self.$_getAccounts();
          },
        });
      };
      if (row.status === 1) {
        // 停用切换成启用
        self.$service
          .post("updateUserStatus", {
            uidList,
            status: 1,
          })
          .then((result) => {
            if (result.$.checkResult(result, true)) {
              callback(result.msg);
            } else {
              self.dataList[$index].status = 1;
            }
          });
      } else if (row.status === 2) {
        // 启用切换成停用
        $MessageBox.confirm({
          content: `
            <div>您的账户已开通其他三方系统（如OAC系统），若停用后将无法使用，是否停用？</div>
          `,
          onOk() {
            self.$service
              .post("updateUserStatus", {
                uidList,
                status: 2,
              })
              .then((result) => {
                if (result.$.checkResult(result, true)) {
                  callback(result.msg);
                } else {
                  self.dataList[$index].status = 2;
                }
              });
          },
          onCancel() {
            if (status === 2) {
              self.dataList[$index].status = 1;
            }
          },
        });
      }
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getAccounts();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getAccounts();
    },
    // 批处理confirm
    $_batching(code) {
      let self = this;
      let status = 0,
        content = "";
      code === "on"
        ? ((status = 1), (content = "是否启用所选中的账号？"))
        : code === "off"
        ? ((status = 2), (content = "是否停用所选中的账号？"))
        : ((status = 3), (content = "是否删除所选中的账号？"));
      $MessageBox.confirm({
        content,
        onOk() {
          let uidList = self.selectList.reduce(
            (prev, curr) => prev.concat(curr.uid),
            []
          );
          self.$_batchStatus(uidList, status);
        },
      });
    },
    // 批处理状态
    $_batchStatus(uidList, status) {
      let self = this;
      this.isLoading = true;
      this.$service
        .post("updateUserStatus", {
          uidList,
          status,
        })
        .then((result) => {
          if (result.$.checkResult(result, true)) {
            $MessageBox.alert({
              content: result.msg,
              onOk() {
                self.$_getAccounts();
              },
            });
          }
          this.isLoading = false;
        });
    },
  },

  components: {
    modalModify,
    BatchAccount,
    BatchAuth,
  },

  mounted() {
    let height = this.$refs.tableList.$el.parentElement.clientHeight;
    this.tableHeight = `${height}px`;
    this.$_getAccounts();
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
}
.page-main__wrapper {
  overflow: hidden;
  position: relative;
}

.filter-box {
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px 20px;

  .top-btns {
    min-height: 40px;
    .handle-drop {
      display: inline-block;
      vertical-align: middle;
      margin-right: 10px;
    }
  }

  .filter-form {
    .el-form-item {
      margin-top: 12px;
    }
  }
}

.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
  // margin-bottom: 44px;
  .status__on {
    background: #84888c;
    &:hover {
      background-color: #9a9ea1;
    }
    &:focus {
      background-color: #6f7378;
    }
  }
}
/deep/ .el-table__body-wrapper .cd-switch {
  margin: 0 10px;
}
</style>


